module.exports = __webpack_public_path__ + "img/pattern-festival-phone-bg.0f566a1d.jpg";